import { render } from "./uesrAdd.vue?vue&type=template&id=3a78387c&scoped=true"
import script from "./uesrAdd.vue?vue&type=script&lang=js"
export * from "./uesrAdd.vue?vue&type=script&lang=js"

import "./uesrAdd.vue?vue&type=style&index=0&id=3a78387c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a78387c"]])

export default __exports__